import { EmployeeLocation } from '@/api/types';
import {
  useCreateHomeLocationMutation,
  useHomeLocationQuery,
  useUpdateHomeLocationMutation,
} from '@/queries/homelocation';
import { getChangedValues } from '@/utils/helpers';

type HomeLocationForm = {
  country: string;
  region?: string;
  regionId?: string;
  addressLine: string;
  state: string | null;
  city: string;
  postalCode: string;
  latitude: number | null;
  longitude: number | null;
  timezone: string;
};

export const useSetHomeLocation = (locationId?: string) => {
  const { data } = useHomeLocationQuery(locationId);
  const { mutateAsync: createLocation } = useCreateHomeLocationMutation();
  const { mutateAsync: updateLocation } = useUpdateHomeLocationMutation();

  const setHomeLocation = async (values: HomeLocationForm) => {
    const { country, region, addressLine, state, city, postalCode, latitude, longitude, regionId, timezone } = values;
    const locationBody = {
      country,
      addressLine,
      state,
      city,
      postalCode,
      region: region || null,
      regionId: regionId || null,
      latitude: latitude || 0,
      longitude: longitude || 0,
      timezone,
    };

    let homeLocationId = locationId;
    if (homeLocationId) {
      const changedLocationValues = getChangedValues<Partial<EmployeeLocation>>(locationBody, data as EmployeeLocation);
      if (!Object.keys(changedLocationValues).length) {
        return homeLocationId;
      }
      await updateLocation({ ...locationBody, id: homeLocationId });
    } else {
      homeLocationId = (await createLocation(locationBody)).id;
    }
    return homeLocationId;
  };

  return setHomeLocation;
};
